import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {baseUrl} from "../Univ.js";
import "./IoTStyles.css";
function IoTAlarms() {
    const [alarms, setAlarms] =
        useState([]);
    const [loading, setLoading] =
        useState(false);
    const fetchAlarms = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                baseUrl +
                "iot-alarms/"
            );
            setAlarms(
                response.data
            );
        } catch (error) {
            console.log(error);
            Swal.fire(
                "Error",
                "Unable to load alarms.",
                "error"
            );
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchAlarms();
        const timer =
            setInterval(
                fetchAlarms,
                2000
            );
        return () =>
            clearInterval(timer);
    }, []);
    const acknowledgeAlarm =
        async (id) => {
            try {
                await axios.patch(
                    baseUrl +
                    "iot-alarms/" +
                    id +
                    "/acknowledge/",
                    {
                        status:
                            "ACKNOWLEDGED"
                    }
                );
                Swal.fire({
                    title: "Acknowledged",
                    icon: "success",
                    timer: 1200,
                    showConfirmButton: false
                });
                fetchAlarms();
            } catch (error) {
                console.log(error);
                Swal.fire(
                    "Error",
                    "Unable to acknowledge alarm.",
                    "error"
                );
            }
        };
    const severityClass =
        (severity) => {
            if (
                severity ===
                "CRITICAL"
            ) {
                return "iot-alarm-critical";
            }
            if (
                severity ===
                "WARNING"
            ) {
                return "iot-alarm-warning";
            }
            return "iot-alarm-info";
        };
    return (
        <section className="container-fluid mt-4">

            <div className="iot-page-header">

                <div>

                    <h3>
                        IoT Alarms
                    </h3>

                    <p>
                        Active device and patient monitoring alarms
                    </p>

                </div>

            </div>


            {loading && (
                <div className="text-muted mb-3">
                    Updating alarms...
                </div>
            )}


            {alarms.length === 0 ? (
                <div className="card shadow-sm">

                    <div className="card-body text-center">

                        <h5>
                            No Active Alarms
                        </h5>

                        <p className="text-muted">
                            All IoT systems are currently normal.
                        </p>

                    </div>

                </div>
            ) : (
                <div className="row g-3">

                    {alarms.map(
                        alarm => (
                            <div
                                className="col-lg-6"
                                key={
                                    alarm.id
                                }
                            >

                                <div
                                    className={
                                        "card shadow-sm " +
                                        severityClass(
                                            alarm.severity
                                        )
                                    }
                                >

                                    <div className="card-body">

                                        <div className="d-flex justify-content-between align-items-center">

                                            <div>

                                                <span className="badge bg-dark">

                                                    {
                                                        alarm.severity
                                                    }

                                                </span>

                                                <span className="ms-2 text-muted">

                                                    Device:
                                                    {" "}
                                                    {
                                                        alarm.device
                                                    }

                                                </span>

                                            </div>


                                            <small>

                                                {
                                                    alarm.created_at
                                                }

                                            </small>

                                        </div>


                                        <h5 className="mt-3">

                                            {
                                                alarm.parameter
                                            }

                                            {" = "}

                                            {
                                                alarm.value
                                            }

                                        </h5>


                                        <p>

                                            {
                                                alarm.message
                                            }

                                        </p>


                                        <button
                                            className="btn btn-success btn-sm"
                                            onClick={() =>
                                                acknowledgeAlarm(
                                                    alarm.id
                                                )
                                            }
                                        >
                                            Acknowledge
                                        </button>

                                    </div>

                                </div>

                            </div>
                        )
                    )}

                </div>
            )}

        </section>
    );
}
export default IoTAlarms;
